export default __webpack_public_path__ + "static/media/paper-clip-grey.96e40d74.svg";